import { UserContext } from "@src/App";
import { getIndividualHall } from "@src/api/weddingHall/individualHall";
import AppHeader from "@src/components/common/appHeader/AppHeader";
import BottomFloatingButton from "@src/components/weddingHall/BottomFloatingButton";
import HallImgCarousel from "@src/components/weddingHall/infomation/HallImgCarousel";
import HallAddInfoSection from "@src/components/weddingHall/infomation/hallDetail/HallAddInfoSection";
import HallDetailInfoSection from "@src/components/weddingHall/infomation/hallDetail/HallDetailInfoSection";
import HallSignificantSection from "@src/components/weddingHall/infomation/hallDetail/HallSignificantSection";
import WaitingRoomAndBanquetHallSection from "@src/components/weddingHall/infomation/hallDetail/WaitingRoomAndBanquetHallSection";
import { UMOMENT_HALL } from "@src/types/realtimeBooking";
import { IndividualHall } from "@src/types/weddingHall";
import { HOSTNAME, isExternalUrl } from "@src/utils";
import useDuplicateBooking from "@src/utils/hooks/useBookingState";
import { useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

const BigDivider = () => {
  return <div style={{ height: "12px", backgroundColor: "#F2F2F2" }}></div>;
};

export default function HallDetail() {
   const {isDuplicateBooking, setIsDuplicateBooking, getDuplicateReservation} = useDuplicateBooking();
  const { uuid: partnerUuid, individualHallUuid } = useParams<{
    uuid: string;
    individualHallUuid: string;
  }>();
  const location = useLocation();
  const partnerId = location.state;
  const user = useContext(UserContext);

  const [hallInfo, setHallInfo] = useState<IndividualHall>();

  useEffect(() => {
    getIndividualHall(partnerUuid, individualHallUuid).then((res) => {
      setHallInfo(res.data.item);
    });
  }, []);

  return (
    <>
      {hallInfo && (
        <section>
          <AppHeader type="stack" title={hallInfo.name} scrollHide={false} />
          <section>
            <HallImgCarousel type="hallDetail" height={375} imgs={hallInfo.images} />
          </section>
          <HallDetailInfoSection
            weddingGapMinutes={hallInfo.weddingGapMinutes}
            weddingTime={hallInfo.weddingTime}
            seatedCapacity={hallInfo.seatedCapacity}
            capacity={hallInfo.capacity}
            guaranteedNumberOfPeople={hallInfo.suggestPersonnel}
            style={hallInfo.style}
            height={hallInfo.height}
            virginRoad={hallInfo.virginRoad}
            regularPrice={hallInfo.regularPrice}
          />
          <WaitingRoomAndBanquetHallSection
            brideRoom={hallInfo.brideRoom}
            banquetHall={hallInfo.banquetHall}
            meals={hallInfo.meals}
            capacity={hallInfo.capacity}
          />
          {hallInfo.tags.length > 0 && (
            <>
              <BigDivider />
              <HallAddInfoSection addInfos={hallInfo.tags} />
            </>
          )}
          {hallInfo.note && (
            <>
              <BigDivider />
              <HallSignificantSection significant={hallInfo.note} />
            </>
          )}
          <BottomFloatingButton
            partnerId={partnerId}
            buttonName='방문 예약하기'
            isOpenWriteReviewModal={false}
            onClose={() => {}} //리뷰 모달 닫기
            handleRightBtnClick={async()=>{
              if (partnerUuid && UMOMENT_HALL.has(partnerUuid)) {
                window.location.href = isExternalUrl(`${HOSTNAME}/booking/real-time/${partnerUuid}/${partnerId}/visit-date`);
              } else{
                await getDuplicateReservation(partnerUuid, user.me?.uuid, partnerId, true);
              }
            }}
            isDuplicateBooking={isDuplicateBooking}
            setIsDuplicateBooking={(bool)=>setIsDuplicateBooking(bool)}
          />
        </section>
      )}
    </>
  );
}
